import { useEffect } from 'react'
import { CommonActions, useAppDispatch, useAppSelector } from '../../stores'

export function usePageTitle(title: string) {
  const beforePage = useAppSelector((state) => state.common.beforePageTitle)
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(CommonActions.setPageTitle(title))
    return () => {
      dispatch(CommonActions.setPageTitle(''))
      dispatch(CommonActions.setBeforePageTitle(title))
    }
  })
  return beforePage
}
